import {useUrl} from '@shopify/hydrogen';

import {manualUrlParams} from '~/consts/urlParams';

// Has potential to be expanded upon, but this is a place to put common
// operations on URL params, to be as clear as possible in managing
// complex combinations of searching, filtering, window history state, variants, etc.
export const useParamHelper = () => {
  const {pathname, searchParams} = useUrl();

  // Method to delete all params that we would not explicitly expect on a base route (variants; filters),
  // but keep all params otherwise (search term, pagination controls, etc.).
  // Accepts an optional prefix to preserve parameters of a certain pattern - this is useful in
  // holding onto Searchspring filters, for instance, via "filter." as an argument
  const scrubNonManualParams = (exceptWithPrefix = null) => {
    // Using `Array.from()` to avoid deletion-in-place errors
    Array.from(searchParams.keys()).forEach((key) => {
      if (
        !Object.values(manualUrlParams).includes(key) &&
        !key.startsWith(exceptWithPrefix)
      ) {
        searchParams.delete(key);
      }
    });

    window.history.replaceState(
      null,
      '',
      `${pathname}?${searchParams.toString()}`,
    );
  };

  // Boolean to inform on the above concept of non-manual params
  const hasNonManualParams = Array.from(searchParams.keys()).some(
    (key) => !Object.values(manualUrlParams).includes(key),
  );

  return {hasNonManualParams, scrubNonManualParams};
};
